export const formatNumber = ({ value = 0, locale, maximumFractionDigits = 2 }: FormatNumberArgs): string => {
  // Round the value up to the maximum number of fraction digits
  const roundedValue =
    Math.round((value ?? 0) * Math.pow(10, maximumFractionDigits)) / Math.pow(10, maximumFractionDigits);

  return new globalThis.Intl.NumberFormat(locale, {
    maximumFractionDigits,
  }).format(roundedValue);
};

type FormatNumberArgs = {
  value?: number | null;
  locale: string;
  maximumFractionDigits?: number;
};
